var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.429 2 2 6.429 2 12s4.429 10 10 10 10-4.429 10-10S17.571 2 12 2Zm0 18.571c-4.714 0-8.571-3.857-8.571-8.571 0-4.714 3.857-8.571 8.571-8.571 4.714 0 8.571 3.857 8.571 8.571 0 4.714-3.857 8.571-8.571 8.571Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.857 17 12 13.143 8.143 17 7 15.857 10.857 12 7 8.143 8.143 7 12 10.857 15.857 7 17 8.143 13.143 12 17 15.857 15.857 17Z",
    fill: "#666"
  })));
};
export default SvgCloseCircle;